import * as React from 'react'
import { Reference } from './../domain/models'

interface ReferencesContainerProps {
    references: Reference []
}

interface FancyBoxLinkProps {
    mainPictureId: number
    pictureId: number
}

export const FancyBoxLink = ( props: FancyBoxLinkProps ) => {
    const { mainPictureId, pictureId } = props

    return (
        <a
            className='fancybox'
            data-type='image'
            data-fancybox={ 'group_' + mainPictureId }
            rel={ 'gallery_' + mainPictureId }
            href={ '/Home/GetImage/' + pictureId }></a>
    )
}

export const GalleryDiv = ( props: ReferencesContainerProps ) => {
    const { references } = props

    // todo: find a type more descriptive than any
    const fancyboxLinks = Array<any>();
    references.forEach( ( reference ) => {
        reference.PicturesIds.forEach( ( picId ) =>
            fancyboxLinks.push (<FancyBoxLink key={ picId } mainPictureId={ reference.MainPictureId } pictureId={ picId }/>)
        )
    } )

    return (
        <div id='gallery-div' className='hidden'>
            {fancyboxLinks.map((fd)=> fd)}
        </div>
    )
}

export const ReferencesContainer = ( props: ReferencesContainerProps ) => {
    const { references } = props

    return (
        <div>
            <div className='thumb-box12'>
                <div className='container'>

                    <div className='reference-row'>
                        {props.references.map( ( item =>
                            <ReferenceItem key={item.Name}
                                reference={item} />
                        ) )}
                    </div>

                </div>
            </div>
            <GalleryDiv references={references} />
        </div>
    )
}

export interface ReferencesItemProps {
    reference: Reference
}

export const ReferenceItem = ( props: ReferencesItemProps ) => {
    const { reference } = props

    return (
        <div className='col-md-4'>
            <div className='reference-img-container'>
                <a
                    className='fancybox fancybox-trigger image-container'
                    data-trigger-rel={'gallery_' + reference.MainPictureId}
                    data-fancybox={'group_' + reference.MainPictureId}
                    href={'/Home/GetImage/' + reference.MainPictureId}
                    data-type='image' >

                    <img 
                        src={'/Home/GetImage/' + reference.MainPictureId}
                        className='img-referece' alt=''></img>
                    
                        <div className='after'>
                            <span className='content'>
                                <h3>Kliknutím zobrazíte galerii</h3>
                                {reference.Description}
                            </span>
                            <span className='zoom'>
                            </span>
                        </div>
                </a>

                <div className='caption'>
                    <br />
                    <label>{reference.Name + ', ' + reference.Year}</label>
                    <p>{reference.Area}</p>
                    {reference.CategoriesIsReferenceOf.map( ( cn ) => 
                        <a 
                            key={cn.Id}
                            href='#'
                            className='btn-default referenceCategory'>{cn.Name}</a> )}
                </div>
            </div>
        </div>
    )
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/components/ReferencesContainer.tsx
 **/